import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import About from "../components/Layout/Home/About";
import Blog from "../components/Layout/Home/Blog";
import Cta from "../components/Layout/Home/Cta";
import Hero from "../components/Layout/Home/Hero";
import Projects from "../components/Layout/Home/Projects";
import Skills from "../components/Layout/Home/Skills";
import ToTop from "../assets/to-top.svg";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);

const Home = () => {
  const [showToTop, setShowToTop] = useState(false);
  const location = useLocation();

  const scrollTo = (target) => {
    gsap.to(window, {
      duration: 2,
      scrollTo: { y: target, offsetY: 0 },
    });
  };

  useEffect(() => {
    if (location.state?.scrollTo === "projects") {
      setTimeout(() => scrollTo("#projects"), 100);
    }
  }, [location.state]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 2000) {
        setShowToTop(true);
      } else {
        setShowToTop(false);
      }
    });
  }, []);
  return (
    <div className="font-sans">
      <Hero />
      <About />
      <div id="projects">
        <Projects />
      </div>
      <Skills />
      <Cta />
      <Blog />
      {showToTop && (
        <img
          onClick={() => scrollTo("#navbar")}
          src={ToTop}
          alt="back to top"
          className="fixed bottom-12 w-10 cursor-pointer z-[1000] right-12
      "
        />
      )}
    </div>
  );
};

export default Home;
